<template>
  <div class="gp_dropdown" :class="[popupDirection, { initiating: initiating }]" v-clickaway="closeDropdown">
    <!-- <div class="gp_dropdown" :class="[{ ('position-' + popupDirection): positioning }]" v-clickaway="closeDropdown"> -->
    <template v-if="hasTooltip">
      <button type="button" class="btn dropdown_toggle" :class="[bclass, { active: showDropdown }]" ref="inputBounder" @click="toggleDropdown" v-popover:tooltip.bottom="tooltipText">
        <slot name="button">Toggle Dropdown</slot>
        <i class="icon" :class="arrowDirection" v-if="!hideArrow" />
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="9.348" height="5" viewBox="0 0 9.348 5" v-if="!hideArrow">
          <g transform="translate(-6.4 -33.4)">
            <path fill="currentColor" d="M15.652 33.5a.33.33 0 0 0-.467 0l-4.107 4.115L6.964 33.5a.33.33 0 0 0-.467.467l4.34 4.34a.322.322 0 0 0 .234.1.336.336 0 0 0 .234-.1l4.34-4.34a.324.324 0 0 0 .007-.467z" />
          </g>
        </svg> -->
        <!-- <i class="icon icon-arrow-down" v-if="!hideArrow"></i> -->
      </button>
    </template>

    <template v-else>
      <button type="button" class="btn dropdown_toggle" :class="[bclass, { active: showDropdown }]" ref="inputBounder" @click="toggleDropdown">
        <slot name="button">Toggle Dropdown</slot>
        <i class="icon" :class="arrowDirection" v-if="!hideArrow" />
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="9.348" height="5" viewBox="0 0 9.348 5" v-if="!hideArrow">
          <g transform="translate(-6.4 -33.4)">
            <path fill="currentColor" d="M15.652 33.5a.33.33 0 0 0-.467 0l-4.107 4.115L6.964 33.5a.33.33 0 0 0-.467.467l4.34 4.34a.322.322 0 0 0 .234.1.336.336 0 0 0 .234-.1l4.34-4.34a.324.324 0 0 0 .007-.467z" />
          </g>
        </svg> -->
        <!-- <i class="icon icon-arrow-down" v-if="!hideArrow"></i> -->
      </button>
    </template>
    <transition :name="initiating ? '' : 'fadeIn'">
      <div class="gp_dropdown_list" :class="lclass" ref="dropContain" v-if="showDropdown" :style="initiating ? 'z-index: -999; opacity: 0' : ''">
        <slot>Dropdown items</slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    bclass: String,
    lclass: String,
    hideArrow: {
      type: Boolean,
      default: false
    },
    positioning: {
      type: Boolean,
      default: true
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipType: String
  },
  data() {
    return {
      showDropdown: false,
      inVP: true,
      elHeight: 0,
      initiating: false
    };
  },
  computed: {
    popupDirection() {
      if (!this.positioning) return "";
      let pos = "position-";
      if (this.inVP) {
        return pos + "down";
      }
      return pos + "up";
    },
    arrowDirection() {
      let pos = "icon-arrow-";
      // if (!this.positioning) return "icon-arrow-up";
      // if (this.inVP) {
      //   return pos + "up";
      // }
      // return pos + "down";
      if (this.inVP) {
        if (this.showDropdown) {
          return pos + "up";
        }
        return pos + "down";
      }
      if (this.showDropdown) {
        return pos + "down";
      }
      return pos + "up";
    },
    tooltipText() {
      switch (this.tooltipType) {
        case "page":
        case "group":
          return this.$tc("generals.option", 2);
      }
      return "";
    }
  },
  watch: {
    showDropdown() {
      if (this.$refs && this.$refs.dropContain) this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
    },
    elHeight() {
      this.autoPosition();
    }
  },
  created() {
    this.$emit("created", this);
    window.addEventListener("scroll", this.autoPosition);
    window.addEventListener("mousewheel", this.autoPosition);
    window.addEventListener("ps-scroll-y", this.autoPosition);
    window.addEventListener("resize", this.autoPosition);
    this.initFirst();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.autoPosition);
    window.removeEventListener("mousewheel", this.autoPosition);
    window.removeEventListener("ps-scroll-y", this.autoPosition);
    window.removeEventListener("resize", this.autoPosition);
  },
  methods: {
    initFirst() {
      this.initiating = true;
      this.toggleDropdown();
      this.$nextTick(() => {
        this.autoPosition();
        this.toggleDropdown();
        this.initiating = false;
      });
    },
    toggleDropdown() {
      if (this.showDropdown) {
        this.showDropdown = false;
      } else {
        this.showDropdown = true;
      }
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    autoPosition() {
      if (!this.$refs) return;
      if (!this.$refs.inputBounder) return;
      if (this.$refs.dropContain) {
        this.elHeight = this.$refs.dropContain.getBoundingClientRect().height;
      }
      let viewportTop = window.pageYOffset,
        viewportBottom = window.pageYOffset + window.document.documentElement.clientHeight - 80,
        rect = this.$refs.inputBounder.getClientRects()[0],
        elementTop = rect ? rect.top : 0,
        elementBottom = rect ? rect.bottom : 0;
      if (elementBottom + this.elHeight <= viewportBottom) {
        this.inVP = true;
        return;
      }
      if (elementTop - this.elHeight >= viewportTop + 60) {
        this.inVP = false;
        return;
      }
      this.inVP = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  &-enter-active {
    animation-name: fadeIn;
    animation-duration: 0.2s;
  }

  &-leave-active {
    animation-name: fadeIn;
    animation-duration: 0.2s;
    animation-direction: reverse;
  }
}

.gp_dropdown {
  position: relative;
  display: flex;
  // flex-direction: row;
  // margin-left: auto;
  align-items: center;
  // align-self: center;
  font: inherit;
  color: #627381;

  &:hover {
    .gp_dropdown-button {
      background: $textDarkModeHigh;
    }
  }

  .dropdown_toggle {
    align-self: center;
    padding: 12px 15px;
    display: flex;
    align-items: center;
    flex: 1;

    i {
      margin-left: auto;
      @include trans-all;
    }

    &.active {
      i[class^="icon-arrow-"] {
        transform: rotate(180deg);
      }
    }
  }

  &_list {
    $arrowHeight: 10px;
    $arrowWidth: 10px;

    position: absolute;
    display: flex;
    flex-flow: column;
    top: calc(100% + 8px);
    width: 100%;
    right: 0px;
    z-index: $z-index-highest;
    transform: translate(0, 0);
    transition: z-index 0ms linear, opacity 0ms linear;

    box-shadow: 0px 0.332071px 0.719487px rgba(0, 0, 0, 0.0168687), 0px 0.798012px 1.72903px rgba(0, 0, 0, 0.0242336), 0px 1.50259px 3.2556px rgba(0, 0, 0, 0.03), 0px 2.68036px 5.80744px rgba(0, 0, 0, 0.0357664), 0px 5.01331px 10.8622px rgba(0, 0, 0, 0.0431313), 0px 12px 26px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;

    &.recent-pages {
      top: calc(100% - 4px);
    }
  }

  &.position-up &_list {
    top: unset;
    bottom: calc(100% + 8px);
    &.recent-pages {
      bottom: calc(100% + 6px);
    }
  }
}
</style>
<style lang="scss">
.gp_dropdown-item {
  padding: 8px 16px;
  padding-left: 14px;
  border-left: 3px solid $light1;
  @include trans-all;
  text-decoration: none;
  color: $textLightModeHigh;
  &.disable {
    opacity: 0.3;
    cursor: default;
  }
  &:not(.disable):not(.active):hover {
    cursor: pointer;
    border-left: 3px solid $light2;
    background: $light2;
  }
  &.active {
    cursor: pointer;
    border-left: 3px solid $textLightModeHigh;
    background: $light2;
  }
}

.gp_dropdown-setting {
  padding: 11px 16px 12px 16px;
  @include trans-all;
  text-decoration: none;
  color: $textLightModeHigh;
  &.disabled {
    background: $light1;
    cursor: default;
    color: $textLightModeDisabled;
    i, i::before,
    p {
      color: $textLightModeDisabled !important;
    }
    svg,
    svg path,
    svg circle {
      fill: $textLightModeDisabled;
    }
  }
  &:not(.disabled):hover {
    cursor: pointer;
    background: $light2;
  }

  &:first-child {
    border-bottom: 1px solid $bg;
  }

  &-border-bottom {
    border-bottom: 1px solid $bg;
  }

  &:last-child {
    border-top: 1px solid $bg;
  }
}

.gp_dropdown-button {
  @include flex-center(inline-flex);
  padding: 5px;
  border-radius: $radius;
  background: none;

  &:hover {
    background: $textDarkModeHigh;
  }

  .icon {
    @include trans-all;
    color: $textLightModeHigh;
  }
}
.dropdown_toggle {
  @include trans-all;
}
</style>
